import { getIdpHealth } from '@/services/idpAnalytics'
import type { IdpDataHealthDTO, IdpWebKey } from '@/services/idpAnalytics'
import { webKeysForFilter } from './siteWebKeys'

export type IdpHealthFetcher = (params: { webKey: IdpWebKey }) => Promise<IdpDataHealthDTO | null | undefined>

export function loadIdpHealthSnapshots(
  filterSite: string,
  fetchHealth: IdpHealthFetcher = getIdpHealth,
  siteFilters?: string[],
): Promise<IdpDataHealthDTO[]> {
  return Promise.all(webKeysForFilter(filterSite, siteFilters).map(webKey => fetchHealth({ webKey })))
    .then(list => list.filter(Boolean) as IdpDataHealthDTO[])
}
